// Helper pequeño para almacenar colores por producto solo en POS (localStorage)
const STORAGE_KEY = 'safetypoint_pos_colors_v1';

export function getAllProductColors() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function getProductColor(id) {
  if (!id && id !== 0) return null;
  const all = getAllProductColors();
  return all[id] || null;
}

export function setProductColor(id, color) {
  if (!id && id !== 0) return;
  try {
    const all = getAllProductColors();
    if (color === null || color === undefined || color === '') {
      delete all[id];
    } else {
      all[id] = color;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    return true;
  } catch (e) {
    return false;
  }
}

export function removeProductColor(id) {
  return setProductColor(id, null);
}

export default { getAllProductColors, getProductColor, setProductColor, removeProductColor };
